import './App.css';
import { useState } from 'react'
import WeatherInfo from './Components/WeatherInfo';

function App() {

  return (
    <div>
      <WeatherInfo />
    </div>
  );
}

export default App;
